export default "__VITE_ASSET__42105478__"